import React from "react";

export default function Section2() {
  return (
    <div className="w-full Section2">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        {/* Main Heading */}
        <h1 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
           Shopify Plus Development Company in Texas for Enterprise Ecommerce
        </h1>

        {/* Description under heading */}
        <p className="leading-[22px] text-[#373737] pb-[1%] text-sm md:text-base mb-[20px]">
          Struggling to manage high volume traffic on shopify, large product catalogs, or complex store operations? Mean3 provides Shopify Plus services in Texas to help enterprise brands scale faster with stable performance and seamless shopping experiences.
        </p>

        {/* Cards container */}
        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {/* Card 1 */}
          <div className="bg-[#E42E35] text-white p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%]">
            <h2 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
              Certified Shopify Partner 
            </h2>
            <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
             As an official Shopify Partner, Mean3 delivers trusted, platform-backed expertise to build scalable, high-performing Shopify stores. We follow Shopify best practices to ensure faster development, fewer errors, and seamless use of advanced Shopify Plus features.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#f5f5f5] text-[#373737] p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%]">
            <h2 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
            Shopify Automation
            </h2>
            <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
              Our Shopify Plus developers focus on automating complex workflows for enterprise stores, creating operational processes that save time, improve accuracy, and support scalable, high-performance e-commerce in Texas.
            </p>
          </div>
        </div>
      </div>

      {/* Logos row stays same */}
      <div className="w-[90%] flex justify-center items-center section2-container mx-auto">
        <div className="mx-5">
          <img
            className="w-[120px]"
            alt="Awards Logos"
            src="/assets/go-awards-logo.png"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[97px]"
            alt="Awards Logos"
            src="../../../../assets/award2.png"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[119px]"
            alt="Awards Logos"
            src="../../../assets/secp-logo.jpg"
          />
        </div>

        <div className="mx-5">
          <img
            className="w-[116px]"
            alt="Awards Logos"
            src="/assets/pasha-logo.jpg"
          />
        </div>
      </div>
    </div>
  );
}
